import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const col1 = categories.slice(0, 4);
const col2 = categories.slice(4, 8);
const col3 = categories.slice(8, 11);
const col4 = categories.slice(11, 14);

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          <div>
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">Categories</h4>
            <div className="w-8 h-px bg-primary-500 mb-4"></div>
            <div className="flex flex-col gap-2.5">
              {col1.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">More Categories</h4>
            <div className="w-8 h-px bg-accent-500 mb-4"></div>
            <div className="flex flex-col gap-2.5">
              {col2.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">Also Browse</h4>
            <div className="w-8 h-px bg-secondary-500 mb-4"></div>
            <div className="flex flex-col gap-2.5">
              {col3.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-secondary-500 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">Quick Links</h4>
            <div className="w-8 h-px bg-primary-500 mb-4"></div>
            <div className="flex flex-col gap-2.5">
              {col4.map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
              <Link
                to="/guide/what-is-sugargoo-spreadsheet"
                className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
              >
                Complete Guide
              </Link>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
              >
                Main Store
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div>
            <span className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              Sugargoo <span className="text-primary-500">Spreadsheet</span>
            </span>
            <p className="text-xs text-foreground-500 mt-1">Your trusted guide to smart spreadsheet shopping since 2024</p>
          </div>

          <div className="flex items-center gap-5">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 hover:bg-primary-100 text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
              aria-label="Visit main store"
            >
              <i className="ri-store-2-line text-lg"></i>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 hover:bg-primary-100 text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
              aria-label="Shopping bag"
            >
              <i className="ri-shopping-bag-3-line text-lg"></i>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 hover:bg-primary-100 text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
              aria-label="Browse products"
            >
              <i className="ri-grid-line text-lg"></i>
            </a>
          </div>
        </div>

        <div className="mt-8 text-center">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} Sugargoo Spreadsheet. All external links open to our partner site.
          </p>
        </div>
      </div>
    </footer>
  );
}